
// API base URL - removed hardcoded values for security
export const API_URL = import.meta.env.VITE_API_URL || 'https://api.lainasampo.fi';

// Affiliate ID for tracking
export const AFFILIATE_ID = import.meta.env.VITE_AFFILIATE_ID || 'lainasampo';

// Partner-specific URLs - using secure defaults
export const SORTTER_REDIRECT_URL = 'https://sortter.scaletrk.com/click';
export const SAMBLA_REDIRECT_URL = 'https://rahoitu.fi/application';
export const AXO_REDIRECT_URL = 'https://go.axolaina.fi/aff_c';
export const FINAL_REDIRECT_URL = 'https://lainasampo.fi/kiitos';

// Partner IDs - explicitly defined with secure defaults
export const AXO_OFFER_ID = '820';
export const AXO_AFFILIATE_ID = '1657';

// Sortter IDs
export const SORTTER_OFFER_ID = '147';
export const SORTTER_AFFILIATE_ID = '40';

// Sambla IDs
export const SAMBLA_PUBID = '3691481';

// Add missing exports for Axo
export const AXO_TRACKING_DOMAIN = 'go.axolaina.fi';

// Add missing exports for API usage
export const OFFER_ID = '1';
export const API_KEY = import.meta.env.VITE_API_KEY || '';  // Sensitive, use env var only
export const USE_MOCK_API = true; // Set to false for production

// Add missing exports for Salus API
export const SALUS_API_URL = 'https://api.salus.fi';
export const SALUS_API_KEY = import.meta.env.VITE_SALUS_API_KEY || ''; // Sensitive, use env var only
export const SALUS_API_VERSION = 'v1';
export const SALUS_COUNTRY_CODE = 'FI';
export const USE_MOCK_SALUS_API = true; // Set to false for production
export const SALUS_LOAN_COST_API_URL = 'https://api.salus.fi/loan-cost';

// Add missing exports for Sortter
export const SORTTER_POSTBACK_URL = 'https://api.sortter.fi/postback';

// Add exports for AXO API
export const AXO_NETWORK_ID = '1';
export const AXO_API_KEY = import.meta.env.VITE_AXO_API_KEY || ''; // Sensitive, use env var only
